// Composable for managing recently viewed companies in the sidebar
import { useStorage } from '@vueuse/core'

export interface RecentCompany {
  tickerSymbol: string
  name: string
  isin: string
  logoType: string | null
}

export function useRecentlyViewedCompanies() {
  // Use the cookie directly as the source of truth for reactive updates across the app
  const recentCompanies = useStorage<RecentCompany[]>(useStorageKey('recentlyViewedCompanies'), [])
  
  // Method to add a company to the recent list
  const addRecentCompany = (company: RecentCompany) => {
    if (!company.tickerSymbol || !company.name) {
      return
    }
    
    // Get current value (ensure it's an array)
    const currentList = Array.isArray(recentCompanies.value) ? recentCompanies.value : []
    
    // Remove the company if it already exists (to avoid duplicates and move it to top)
    const filteredCompanies = currentList.filter(
      c => c.tickerSymbol !== company.tickerSymbol
    )
    
    // Add the new company at the beginning
    const updatedCompanies = [company, ...filteredCompanies]
    
    // Keep only the 3 most recent entries and update the cookie
    recentCompanies.value = updatedCompanies.slice(0, 3)
  }
  
  return {
    recentCompanies: readonly(recentCompanies),
    addRecentCompany
  }
}

